export const notify = function (
  message,
  type = "info",
  config = { timeout: 8000, color: "#071b24", },
) {
  this.$dialog.notify[type](message, config);
};
export default notify;
